"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const useStyles = (0, makeStyles_1.default)((theme) => ({
    box: {
        position: "relative",
        right: 0,
        left: 0,
        bottom: 0,
        backgroundColor: "#F1F4F9",
        [theme.breakpoints.down("sm")]: {
            position: "relative",
        },
    },
    sticky: {
        position: "absolute",
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
        },
        [theme.breakpoints.down("xs")]: {
            position: "relative", // In mobile size the footer is positioned relative, even if classed sticky.
        },
    },
    link: {
        color: "black",
        textDecoration: "underline",
    },
    links: {
        [theme.breakpoints.down("xs")]: {
            textAlign: "center",
        },
    },
    linksRight: {
        [theme.breakpoints.down("sm")]: {
            textAlign: "right",
        },
        [theme.breakpoints.down("xs")]: {
            textAlign: "center",
        },
    },
    copyright: {
        textAlign: "right",
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
            paddingTop: theme.spacing(2),
        },
    },
}));
function Footer({ sticky, firstColumnLinks, secondColumnLinks, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const classes = useStyles({ sticky });
    return (react_1.default.createElement(material_1.Box, { pt: 4, pb: 4, pl: 8, pr: 8, className: `${classes.box} ${sticky ? classes.sticky : "-"}` },
        react_1.default.createElement(material_1.Grid, { container: true },
            react_1.default.createElement(material_1.Grid, { className: `${classes.links}`, item: true, md: 3, sm: 6, xs: 12 }, (firstColumnLinks || []).map((row, i) => (react_1.default.createElement(material_1.Link, { key: i, className: classes.link, href: row.href, target: "_blank" },
                react_1.default.createElement(material_1.Typography, { variant: "body1" }, t(row.text)))))),
            react_1.default.createElement(material_1.Grid, { className: `${classes.links} ${classes.linksRight}`, item: true, md: 3, sm: 6, xs: 12 }, (secondColumnLinks || []).map((row, i) => (react_1.default.createElement(material_1.Link, { key: i, className: classes.link, href: row.href, target: "_blank" },
                react_1.default.createElement(material_1.Typography, { variant: "body1" }, t(row.text)))))),
            react_1.default.createElement(material_1.Grid, { item: true, md: 6, xs: 12 },
                react_1.default.createElement(material_1.Box, { className: classes.copyright },
                    react_1.default.createElement(material_1.Typography, { variant: "body1" }, "\u00A9 Luonnonvarakeskus 2021"))))));
}
exports.default = Footer;
